<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title
            primary-title
            style="padding-left: 8px; padding-bottom: 8px; padding-top: 16px"
          >
            <span class="headline mb-0">置き換え</span>
          </v-card-title>
          <v-card-actions>
            <v-btn @click="replaceSend()">置き換え</v-btn>
            <v-btn @click="$router.go(-1)">戻る</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs8>
        <v-card class="replaced">
          <table>
            <tr style="height: 44px">
              <th style="width: 50%">正式納入指示</th>
              <th style="width: 50%">事前納入指示</th>
            </tr>
            <tr
              :class="{ selected: currentSelected === item }"
              :key="item.id"
              @click="select(item)"
              v-for="item in sas"
            >
              <td>
                <div>
                  <label>B/L No:</label>
                  <span>{{ item.blNo }}</span>
                </div>
                <div>
                  <label>DO NO:</label>
                  <span>{{ item.doNo }}</span>
                </div>
                <div>
                  <label>コンテナNo:</label>
                  <span>{{
                    item.packages && item.packages[0].containerNo
                  }}</span>
                </div>
                <div>
                  <label>コンテナサイズ:</label>
                  <span>{{
                    item.packages && item.packages[0].containerTypeName
                  }}</span>
                </div>
                <div>
                  <label>海外取引先:</label>
                  <span>{{ item.partnerCode + ' ' + item.partnerName }}</span>
                </div>
                <div>
                  <label>ETA:</label>
                  <span>{{ item.eta }}</span>
                </div>
                <div>
                  <label>最終納入場所:</label>
                  <span>{{
                    (item.finallyWarehouseCode || '') +
                    ' ' +
                    (item.finallyWarehouseName || '')
                  }}</span>
                </div>
                <div>
                  <label>納入予定日:</label>
                  <span>{{ item.forecastDeliveryDate }}</span>
                </div>
                <div>
                  <label>時間:</label>
                  <span>{{ item.forecastDeliveryTime }}</span>
                </div>
              </td>
              <td>
                <div class="selector" v-if="!item.rightDO"></div>
                <div style="position: relative" v-else>
                  <div>
                    <label>B/L No:</label>
                    <span>{{ item.rightDO.blNo }}</span>
                  </div>
                  <div>
                    <label>DO NO:</label>
                    <span>{{ item.rightDO.doNo }}</span>
                  </div>
                  <div>
                    <label>コンテナNo:</label>
                    <span>{{
                      item.rightDO.packages &&
                      item.rightDO.packages[0].containerNo
                    }}</span>
                  </div>
                  <div>
                    <label>コンテナサイズ:</label>
                    <span>{{
                      item.rightDO.packages &&
                      item.rightDO.packages[0].containerTypeName
                    }}</span>
                  </div>
                  <div>
                    <label>海外取引先:</label>
                    <span>{{
                      item.rightDO.partnerCode + ' ' + item.rightDO.partnerName
                    }}</span>
                  </div>
                  <div>
                    <label>ETA:</label>
                    <span>{{ item.rightDO.eta }}</span>
                  </div>
                  <div>
                    <label>最終納入場所:</label>
                    <span>{{
                      (item.rightDO.finallyWarehouseCode || '') +
                      ' ' +
                      (item.rightDO.finallyWarehouseName || '')
                    }}</span>
                  </div>
                  <div>
                    <label>納入予定日:</label>
                    <span>{{ item.rightDO.forecastDeliveryDate }}</span>
                  </div>
                  <div>
                    <label>時間:</label>
                    <span>{{ item.rightDO.forecastDeliveryTime }}</span>
                  </div>
                  <div style="position: absolute; right: 0; top: 0">
                    <v-icon @click="clear(item)" style="color: red"
                      >clear</v-icon
                    >
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <div class="header">
          <!-- <div class="search-bar"> -->
          <v-text-field
            @click:append="search()"
            append-icon="search"
            placeholder="B/L No"
            style="margin: 0px 5px"
            v-model="blNo"
          ></v-text-field>
          <v-select
            :items="sortItems"
            item-text="text"
            item-value="value"
            prepend-inner-icon="sort"
            style="margin: 0px 5px; width: 35%"
            v-model="sortItem"
          ></v-select>
          <!-- </div> -->
        </div>
        <v-card class="select-panel">
          <div
            :key="item.id"
            class="selectable-list"
            v-for="item in bookingSas"
          >
            <div>
              <div
                :class="
                  item.blNo === (currentSelected && currentSelected.blNo)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>B/L No:</label>
                <span>{{ item.blNo }}</span>
              </div>
              <div
                :class="
                  item.doNo === (currentSelected && currentSelected.doNo)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>DO NO:</label>
                <span>{{ item.doNo }}</span>
              </div>
              <div
                :class="
                  (item.packages && item.packages[0].containerNo) ===
                  (currentSelected &&
                    currentSelected.packages &&
                    currentSelected.packages[0].containerNo)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>コンテナNo:</label>
                <span>{{ item.packages && item.packages[0].containerNo }}</span>
              </div>
              <div
                :class="
                  (item.packages && item.packages[0].containerTypeName) ===
                  (currentSelected &&
                    currentSelected.packages &&
                    currentSelected.packages[0].containerTypeName)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>コンテナサイズ:</label>
                <span>{{
                  item.packages && item.packages[0].containerTypeName
                }}</span>
              </div>
              <div
                :class="
                  item.partnerCode ===
                  (currentSelected && currentSelected.partnerCode)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>海外取引先:</label>
                <span>{{ item.partnerCode + ' ' + item.partnerName }}</span>
              </div>
              <div
                :class="
                  item.eta === (currentSelected && currentSelected.eta)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>ETA:</label>
                <span>{{ item.eta }}</span>
              </div>
              <div
                :class="
                  item.finallyWarehouseCode ===
                  (currentSelected && currentSelected.finallyWarehouseCode)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>最終納入場所:</label>
                <span>{{
                  (item.finallyWarehouseCode || '') +
                  ' ' +
                  (item.finallyWarehouseName || '')
                }}</span>
              </div>
              <div
                :class="
                  item.forecastDeliveryDate ===
                  (currentSelected && currentSelected.forecastDeliveryDate)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>納入予定日:</label>
                <span>{{ item.forecastDeliveryDate }}</span>
              </div>
              <div
                :class="
                  item.forecastDeliveryTime ===
                  (currentSelected && currentSelected.forecastDeliveryTime)
                    ? 'normal'
                    : 'notEqual'
                "
              >
                <label>時間:</label>
                <span>{{ item.forecastDeliveryTime }}</span>
              </div>
            </div>
            <v-icon @click="bindSelect(item)" class="addBtn" v-if="!used(item)"
              >add</v-icon
            >
            <!-- <v-btn @click="bindSelect(item)" class="addBtn">添加至当前选中</v-btn> -->
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      currentSelected: null,
      saId: null,
      blNo: null,
      saRadioGroup: 0,
      bookingSaRadioGroup: 0,
      saSelected: [],
      bookingSaSelected: [],
      show: false,
      bookingSas: [],
      sas: [],
      orderResults: [],
      bookingResults: [],
      data: [],
      sortItem: 'containerNo',
      sortItems: [
        { text: 'B/L No', value: 'blNo' },
        { text: 'コンテナNo', value: 'containerNo' },
        { text: 'コンテナサイズ', value: 'containerSize' },
        { text: '海外取引先', value: 'partnerCode' },
        { text: 'ETA', value: 'eta' },
        { text: '最終納入場所', value: 'finallyWarehouseCode' },
        { text: '納入予定日', value: 'forecastDeliveryDate' },
      ],
    }
  },
  methods: {
    clear(item) {
      this.$set(item, 'rightDO', null)
      this.sas = [...this.sas]
    },
    used(item) {
      return (
        this.sas.filter((s) => s.rightDO && s.rightDO.id === item.id).length > 0
      )
    },
    sort() {
      if ('containerNo' === this.sortItem) {
        this.bookingSas = [
          ...this.bookingSas.sort((a, b) => {
            return (a.packages[0].containerNo || '').localeCompare(
              b.packages[0].containerNo || ''
            )
          }),
        ]
        return
      }
      if ('containerSize' === this.sortItem) {
        this.bookingSas = [
          ...this.bookingSas.sort((a, b) => {
            return (a.packages[0].containerTypeCode || '').localeCompare(
              b.packages[0].containerTypeCode || ''
            )
          }),
        ]
        return
      }
      this.bookingSas = [
        ...this.bookingSas.sort((a, b) => {
          return (a[this.sortItem] || '').localeCompare(b[this.sortItem] || '')
        }),
      ]
    },
    select(item) {
      this.currentSelected = item
    },
    replace() {
      var data = this.sas.filter((s) => s.rightDO && s.rightDO.id != null)
      console.log(data)
      var promiseArray = []
      data.forEach((d) => {
        promiseArray.push(this.createReplacePromise(d))
      })
      Promise.all(promiseArray)
        .then(() => {
          this.$message('', 'SUCCESS')
          this.$router.push('B0600')
        })
        .catch((err) => {
          this.$message('', 'ERROR')
        })
    },
    createReplacePromise(d) {
      return this.$http.put(
        `/delivery-orders/replace/orderId/${d.id}/booking/${d.rightDO.id}`
      )
    },

    replaceSend() {
      var data = this.sas.filter((s) => s.rightDO && s.rightDO.id != null)

      var errorMsg = []
      var arr = []
      var i = 0
      this.dealInstructionSend(data, i, errorMsg)
    },

    dealInstructionSend(data, i, errorMsg) {
      this.$http
        .put(
          `/delivery-orders/replace/orderId/${data[i].id}/booking/${data[i].rightDO.id}`
        )
        .then(() => {
          this.doInstructionSend(i, data, errorMsg)
        })
        .catch(() => {
          errorMsg.push(data[i])
          this.doInstructionSend(i, data, errorMsg)
        })
    },

    doInstructionSend(i, data, errorMsg) {
      if (i < data.length - 1) {
        this.dealInstructionSend(data, i + 1, errorMsg)
      } else {
        if (errorMsg.length === 0) {
          this.$message('', 'SUCCESS')
          this.$router.go(-1)
        }
        if (errorMsg.length > 0) {
          console.log(errorMsg)
          var msg = errorMsg.map((e) => e.blNo + '-' + e.branchCode).join(',')
          this.$message('', msg + ':' + 'ERROR')
          this.$router.go(-1)
        }
      }
    },

    search() {
      if (!this.blNo) {
        this.loadBookingSa()
        return
      }
      this.$http
        .get(`/shipping-advices/booking-sa/bl-no?blNo=${this.blNo}`)
        .then((res) => {
          this.bookingSas = res.data
        })
    },
    popup(id) {
      this.load(id)
    },
    loadSa(id) {
      return this.$http
        .get(`/delivery-orders/booking-sa/${id}/siblings`)
        .then((res) => {
          this.sas = res.data
        })
    },
    loadBookingSa(id) {
      var containerNos = this.sas.map(sa => sa.packages).flat().map(pkg => pkg.containerNo).join(",")
      console.log(containerNos)
      return this.$http
        .get(`/shipping-advices?view=booking-sa`, {
          params: {
            blNo: this.sas[0].blNo,
            eta: this.sas[0].eta,
            containerNo: containerNos,
            containerSize: this.sas[0].packages[0].containerTypeId,
            partnerId: this.sas[0].partnerId,
          },
        })
        .then((res) => {
          this.bookingSas = res.data
        })
    },
    load(id) {
      this.loadSa(id).then(() => {
        this.loadBookingSa(id).then(() => {
          this.sort()
        })
      })
    },
    bindSelect(item) {
      if (this.currentSelected === null) {
        this.$message('', '正式納入指示を選択していません。')
        return
      }
      this.currentSelected.rightDO = item
      this.sas = [...this.sas]
    },
  },
  computed: {},
  mounted() {
    this.load(this.$route.query.id)
  },
  watch: {
    sortItem() {
      this.sort()
    },
  },
}
</script>
<style scoped>
v-card {
  height: 400px !important;
}
.normal {
  display: block;
}
.notEqual {
  display: block;
  color: red;
}

.replaced {
  padding: 15px;
}
.replaced table {
  border-collapse: collapse;
  width: 100%;
}
.replaced table td {
  border-bottom: 1px solid #ccc;
}
.replaced table th {
  text-align: left;
  border-bottom: 1px solid #369;
}
.select-panel {
  padding: 0 5px;
  overflow: scroll;
  max-height: 800px;
}
.selectable-list {
  overflow: scroll;
  display: flex;
  padding: 5px;
  border-bottom: 1px solid #ccc;
}

.selectable-list label {
  display: inline-block;
  font-weight: bold;
  width: 120px;
}

.layout-1 {
  display: flex;
}
tr.selected td {
  /* background: rgb(253, 193, 9); */
  background: #eee;
}

tr td {
  padding: 5px;
}

.selector {
  height: 100%;
}
.addBtn {
  flex: 1;
}
.search-bar {
  display: flex;
  flex-flow: column;
}
.header {
  text-align: center;
  height: 60px;
  font-size: 14px;
  border-bottom: 1px solid #369;
  font-weight: bold;
  display: flex;
}
table td label {
  display: inline-block;
  font-weight: bold;
  width: 120px;
}

.v-card:not(:first-child) {
  margin-top: 0px !important;
}
</style>